// #if [WX_PACKAGE_TYPE=trial]
import { isValid, isExpired } from "../package";
// #endif

export function grid(
	width: number,
	height: number,
	color: string,
	mode?: "full"
): string {
	// FIXME :: Svelte-kit
	if (typeof document === "undefined") return "";
	const canvas = document.createElement("canvas");

	let fillMode = true;
	// #if [WX_PACKAGE_TYPE=trial]
	fillMode = isValid();
	if (!fillMode) {
		const ctx = canvasSize(canvas, width, height, 3, color);
		const expired = isExpired();

		for (let i = 0; i < 3; i++) {
			for (let j = 0; j < 3; j++) {
				renderCell(
					ctx,
					mode,
					width * i,
					width * (i + 1),
					height * j,
					height * (j + 1)
				);
			}
		}

		ctx.font = "10px monospace";
		ctx.fillStyle = expired ? "#ff0000" : "#CCCCCC";
		ctx.translate(width * (expired ? 1.35 : 1.5), height * 1.5);
		ctx.rotate(Math.PI / 6);
		ctx.fillText(
			expired ? atob("VFJJQUwgRVhQSVJFRA==") : atob("VFJJQUw="),
			-15,
			4
		);
	}
	// #endif

	if (fillMode) {
		const ctx = canvasSize(canvas, width, height, 1, color);
		renderCell(ctx, mode, 0, width, 0, height);
	}
	return canvas.toDataURL();
}

function canvasSize(
	canvas: HTMLCanvasElement,
	width: number,
	height: number,
	zoom: number,
	color: string
): CanvasRenderingContext2D {
	canvas.setAttribute("width", (width * zoom).toString());
	canvas.setAttribute("height", (height * zoom).toString());
	const ctx = canvas.getContext("2d");
	ctx.translate(-0.5, -0.5);
	ctx.strokeStyle = color;

	return ctx;
}

function renderCell(
	ctx: CanvasRenderingContext2D,
	mode: string,
	xA: number,
	xB: number,
	yA: number,
	yB: number
) {
	ctx.beginPath();
	ctx.moveTo(xB, yA);
	ctx.lineTo(xB, yB);

	if (mode === "full") ctx.lineTo(xA, yB);
	ctx.stroke();
}
